import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeSelectorComponent',
      'PdpMainComponent',
      'PdpImagesComponent',
      'PdpImagesWallComponent',
      'PdpTabComponent',
      'SkuInfoAccordionComponent',
      'CompleteLookComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'WishlistComponent',
      'RecommendationEngineComponent',
      'EditorialCoverInfiniteComponent',
      'PdpStockLocalizationComponent',
      'PdpPremiumPackagingComponent',
      'ReferencesCarouselComponent',
      'DropdownSizeSelectorComponent',
      // 'SizeGuideComponent',
      // 'CardAddToCartComponent',
      // 'CardNotifyMeComponent'
    ];
  }
}
